module.exports = __webpack_public_path__ + "img/quard2.0f049af8.png";